import { useContext, useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import nookies from "nookies";

import { auth } from "../../firebase/firebase";
import { UserContext } from "@/context/UserContext";
import { idTokenChangedCallback } from "@/hooks/useInitializeApp/idTokenChangedCallback";
import { safeReplace } from "@/utils/navigation";

export function useInitializeApp() {
  const router = useRouter();
  const [loading, setLoading] = useState(true);
  const { setUser } = useContext(UserContext);
  const hasRedirectedRef = useRef(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      (window as any).nookies = nookies;
    }

    const unsubscribe = auth.onIdTokenChanged((authUser) => {
      idTokenChangedCallback(authUser)
        .then((user) => {
          if (!user) {
            const allowedPaths = [
              "/forgottenPassword",
              "/passwordReset",
              "/changePassword",
              "/somethingWentWrong",
            ];
            const onAllowedPath = allowedPaths.includes(router.pathname);
            if (
              !hasRedirectedRef.current &&
              !onAllowedPath &&
              router.pathname !== "/"
            ) {
              hasRedirectedRef.current = true;
              safeReplace(router, "/");
            }
            // Clear session storage on logout to remove cached sidebar items
            sessionStorage.clear();
            return;
          }

          setUser(user);
        })
        .catch(() => {
          if (!hasRedirectedRef.current && router.pathname !== "/") {
            hasRedirectedRef.current = true;
            safeReplace(router, "/");
          }
        })
        .finally(() => {
          setLoading(false);
        });
    });

    return () => unsubscribe();
  }, [setUser]);

  return { loading };
}
